// External library
import Swiper from 'swiper/bundle'

// Component
export default class SliderCards {
    constructor () {
        this.sliders = document.querySelectorAll('[data-slider-cards]') // cards slider selector
        this.options = {
            centerInsufficientSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {},
            init: false
        }

        if (!this.sliders)
            return

        this.setupSliders()
    }

    setupSliders () {
        this.sliders.forEach(item => {
            const ctrlNext = item.querySelector('.swiper-button-next')
            const ctrlPrev = item.querySelector('.swiper-button-prev')

            this.options.navigation = {
                nextEl: ctrlNext,
                prevEl: ctrlPrev
            }

            const swiper = new Swiper(item, this.options)
            swiper.init()
        })
    }
}
